import React from 'react';
import { Layout } from 'antd';

const { Content } = Layout;

interface AdminContentShellProps {
  isMobile: boolean;
  children: React.ReactNode;
}

export const AdminContentShell: React.FC<AdminContentShellProps> = ({ isMobile, children }) => {
  return (
    <Content
      style={{
        padding: isMobile ? 12 : 16,
        background: '#f5f6f8',
        minHeight: 0,
        overflow: 'auto',
      }}
    >
      {children}
    </Content>
  );
};

export default AdminContentShell;
